__turbopack_context__.v({
  "className": "_29KYLW_className",
  "variable": "_29KYLW_variable",
});
